import { HTMLAttributes } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { KeyOf } from '~/types';
import { ContentKeys } from '~/styles/themes';
import * as ICON_LIST from '~/assets/img/icons';

export interface IconProps extends HTMLAttributes<SVGSVGElement> {
  iconName?: KeyOf<typeof ICON_LIST>;
  size?: number;
  color?: ContentKeys;
  opacity?: number;
}

export default function Icon({
  iconName = 'Wishlist',
  size = 24,
  color,
  opacity,
  ...props
}: IconProps) {
  const IconSVG = ICON_LIST[iconName];

  return (
    <IconWrapper color={color} opacity={opacity}>
      <IconSVG height={size} width={size} {...props} />
    </IconWrapper>
  );
}

export const IconWrapper = styled.i<
  Pick<IconProps, 'size' | 'color' | 'opacity'>
>`
  ${({ theme, color, opacity }) => css`
    display: flex;
    width: fit-content;
    opacity: ${opacity};
    color: ${color ? theme.content[color] : 'inherit'};
  `}
`;
